import { ContentLayout } from "layouts";
import { useTranslation } from "react-i18next";

import { CategoriesLists } from "../CategoriesLists";

const Categories = () => {
  const { t } = useTranslation();
  return (
    <ContentLayout title={t("Categories")}>
      <CategoriesLists />
    </ContentLayout>
  );
};

export default Categories;
